module.exports = __webpack_public_path__ + "img/other.9a29568e.svg";